import createConverter from './lib/create_converter';
import CustomerNote from 'models/customer_note';

export default createConverter(CustomerNote);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/customer_note_converter.js